module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	"use strict";
	fox.registerWidget('PassRecovery_Form', {

		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'forgot_form',
				widgets: {
					forgotPassword: {
						widget: 'PasswordRecovery'
					},
					forgotForm: {
						widget: 'Form',
						formContainer: '#recovery-form',
						formElements: {
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							}
						},
						submit: {
							target: '#recovery-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['email'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:formIsSubmitted',
							onSubmit: '@parent:formSubmit'
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:formNotValid'
							}
						}
					}
				},

				handleDom: {
					focus: {
						target: 'input[name]',
						event: 'focus',
						callback: '_handleFocus'
					}
				},

				handleWom: {
					hashValidation: {
						widget: '#forgotPassword',
						event: 'validateHash',
						callback: '_handleHashValidation'
					},
					recoveryEmailResponse: {
						widget: '#forgotPassword',
						event: 'sendRecoveryMail',
						callback: '_handleRecoveringEmailResponse'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			this.forgotPassword = this.rwom1('#forgotPassword');
			this.notices = fox.wom.selectFirst('~.Layout_Promo_Auth ~#throughNotifications');
		},

		formSubmit: function (values) {
			this.forgotPassword.sendRecoveryMail(values.email);
			var button = fox.dom.selectFirst('.button-with-spinner', this.element);
			fox.dom.addClass('spin', button);
		},

		formNotValid: function (errorsObj) {
			fox.each(errorsObj.errorStack, function (arr, name) {
				var err = arr[0];

				$(this.dom1('[name="' + name + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		formIsSubmitted: function (response) {
			this.form.ignoreSubmit(false);
		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		_handleRecoveringEmailResponse: function (response) {
			if (!response.success) {
				this.notices.pushNotification({
					noticeTemplate: 'new_notice',
					noticeType: 'error',
					noticeMessage: response.text,
					noticeAlias: 'loginError',
					delayClose: 3000
				});
				var button = fox.dom.selectFirst('.button-with-spinner', this.element);
				fox.dom.removeClass('spin', button);
			} else {
				$('.fill').text(response.text);
				$('.action-btns').html('<a href="/" class="btn btn-primary">OK</a>').css({'justify-content': 'center'});
			}
		}

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/passRecovery/form.js
// module id = 210
// module chunks = 5